module.exports = __webpack_public_path__ + "static/img/avatar-s-8.2579bd6d.png";